import ProductCollection from '../components/ProductCollection';

export default function CatalogPage() {
  return <>
    <ProductCollection />
  </>;
}
